export default {
  searchTitle: '搜索结果',
  searchPlaceholder: '搜索文章...',
  searchButton: '搜索',
  searchLoading: '搜索中...',
  // 含 query 的副标题前缀：组件内拼接 query（如 "搜索：色调"）
  searchResultsForPrefix: '搜索：',
  searchEmptyTitle: '未找到结果',
  // 含 query 的空结果说明：组件内拼接 prefix + query + suffix
  searchEmptyQueryPrefix: '未找到与“',
  searchEmptyQuerySuffix: '”相关的文章',
  searchResultCount: '{count} 条结果',
};
